// Billing-status client for hallpass-backend's passes-api. See
// src/api/config.ts's PASSES_API_BASE and src/api/http.ts's passesApi().
//
// Route reference (apps/passes-api/src/routes/passes.ts):
//   GET /api/passes/billing-status  any authenticated school member
//     (requireAuth + requireSchoolMembership, no role gate) — the caller's
//     own school's free-pass billing status.
//
// Response shape (apps/passes-api/src/routes/passes.ts's
// BillingStatusResponse): freePassLimit/remaining are null when isPaid is
// true; otherwise freePassLimit is the lifetime free-pass cap and
// remaining = max(freePassLimit - passCount, 0).

import { passesApi } from './http';
import type { components } from './types.gen';

type BillingStatusResponse = components['schemas']['BillingStatusResponse'];

/**
 * Fetch the caller's school's billing status.
 */
export function getBillingStatus(): Promise<BillingStatusResponse> {
  return passesApi<BillingStatusResponse>('/api/passes/billing-status');
}
